import React, { useEffect, useLayoutEffect, useState } from "react";
import { StyleSheet, View, TextInput, ScrollView, Text } from "react-native";
import { colors } from "src/assets";
import { Button } from "src/components";
import { Row } from "./components";
import { useNavigation, useRoute } from "@react-navigation/native";
import { EventRegister } from "react-native-event-listeners";
import LocalText from "src/local";
import { RootStackScreenProps } from "src/navigation/types";

export type CustomSelectionListItem = {
  id: any;
  label: string;
  search?: string;
};

export type CustomSelectionListNavigationParam = {
  title: string;
  selectedId?: any;
  items: CustomSelectionListItem[];
  eventName: string;
  isMultiply?: boolean;
  isSearchable?: boolean;
  helper?: string;
};

export const CustomSelectionList: React.FC = () => {
  const navigation =
    useNavigation<RootStackScreenProps<"CustomSelectionList">["navigation"]>();
  const route =
    useRoute<RootStackScreenProps<"CustomSelectionList">["route"]>();
  useLayoutEffect(() => {
    navigation.setOptions({ title: route.params.title });
  }, [navigation, route.params.title]);
  const [localSelection, setLocalSelection] = useState<string[]>(
    route.params.selectedId === undefined || route.params.selectedId === null
      ? []
      : typeof route.params.selectedId === "string"
      ? [route.params.selectedId as string]
      : (route.params.selectedId as string[])
  );
  const [localItems, setLocalItems] = useState<CustomSelectionListItem[]>([]);
  const [searchText, setSearchText] = useState<string>("");

  useEffect(() => {
    setLocalItems(
      route.params.items.filter((item) =>
        searchText.length > 0
          ? item.id.toLowerCase().includes(searchText.toLowerCase()) ||
            item.label.toLowerCase().includes(searchText.toLowerCase()) ||
            item.search?.includes(searchText.toLowerCase())
          : true
      )
    );
  }, [searchText, route.params.items]);

  const onSelect = async (id: any) => {
    if (!route.params.isMultiply) {
      EventRegister.emit(route.params.eventName, id);
      navigation.goBack();
    } else {
      if (id === null) {
        setLocalSelection([]);
      } else {
        const array = [...localSelection];
        const index = localSelection.indexOf(id);
        if (index === -1) {
          array.push(id);
        } else {
          array.splice(index, 1);
        }
        setLocalSelection(array);
      }
    }
  };

  return (
    <View style={styles.containerWhite}>
      {route.params.isSearchable && (
        <View
          style={{
            backgroundColor: colors.gray1,
            padding: 8,
            flexDirection: "column",
          }}
        >
          <TextInput
            style={{
              padding: 16,
              margin: 0,
              backgroundColor: colors.white,
              flexDirection: "column",
              borderRadius: 8,
            }}
            value={searchText}
            onChangeText={setSearchText}
            placeholder={"キーワード"}
            placeholderTextColor={"gray"}
          />
          {route.params.helper && (
            <Text style={{ padding: 8 }}>{route.params.helper}</Text>
          )}
        </View>
      )}
      <ScrollView style={styles.scrollView}>
        {localItems.map((item, index) => (
          <Row
            key={index}
            text={item.label}
            selected={
              (item.id === null && localSelection.length === 0) ||
              localSelection.indexOf(item.id) !== -1
            }
            onPress={() => onSelect(item.id)}
          />
        ))}
      </ScrollView>

      <View style={styles.actionContainer}>
        <Button
          containerStyle={styles.action}
          variant={"secondary"}
          icon={"chevron"}
          iconColor={colors.chokuRed}
          iconSize={12}
          title={LocalText.common.back}
          onPress={() => {
            navigation.goBack();
          }}
        />
        {route.params.isMultiply ? (
          <Button
            containerStyle={styles.action}
            variant={"primary"}
            title={LocalText.common.done}
            onPress={() => {
              EventRegister.emit(route.params.eventName, localSelection);
              navigation.goBack();
            }}
          />
        ) : null}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  containerWhite: {
    flex: 1,
    backgroundColor: colors.white,
  },
  containerGray: {
    flex: 1,
    backgroundColor: colors.gray1,
  },
  scrollView: {
    backgroundColor: colors.gray1,
  },
  header: {
    marginTop: 4,
  },
  actionContainer: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    paddingVertical: 16,
    paddingLeft: 16,
    paddingRight: 8,
    shadowColor: colors.black,
    shadowOffset: { width: 0, height: -2 },
    shadowOpacity: 0.1,
    backgroundColor: colors.white,
  },
  action: {
    flex: 1,
    marginRight: 8,
  },
  detail: {
    color: colors.chokuBlack,
  },
});
